<template>
  <slot v-if="isWithinTimeRange"> </slot>
</template>

<script>
import isWithinInterval from "date-fns/isWithinInterval";
import getDay from "date-fns/getDay";
import toDate from "date-fns-tz/toDate";

export default {
  name: "TimeSensitiveWrapper",
  props: {
    businessDays: {
      type: Array,
      default: () => [1, 2, 3, 4, 5],
    },
    startTime: {
      type: String,
      default: "09:30",
    },
    endTime: {
      type: String,
      default: "16:30",
    },
  },
  computed: {
    isWithinTimeRange() {
      const endDate = toDate(new Date(), {
        timeZone: "Europe/London",
      });
      endDate.setHours(...this.endTime.split(":"));
      const startDate = toDate(new Date(), {
        timeZone: "Europe/London",
      });
      startDate.setHours(...this.startTime.split(":"));
      const today = toDate(new Date(), {
        timeZone: "Europe/London",
      });
      const currentDayIndex = getDay(today);
      if (this.isBusinessDay(currentDayIndex)) {
        if (
          isWithinInterval(today, {
            start: startDate,
            end: endDate,
          })
        ) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    isBusinessDay(currentDayIndex) {
      return this.businessDays.includes(currentDayIndex);
    },
  },
};
</script>
